<div class="card__section" *ngIf="records.length > 0">
  <div class="row">
    <div class="columns">
      <h3 class="typography--subheader">Upload Summary</h3>
      <p class="typography--caption">
        <span class="label label--success">{{ records.length }} record(s) processed.</span>
        <span class="label label--info" *ngIf="changes.length > 0" style="margin-left: 8px;">{{ changes.length }} field(s) changed.</span>
      </p>
    </div>
  </div>
  <div class="table" role="table">
    <span role="rowgroup">
      <span class="table__row table__row--header" role="row">
        <span class="table__cell table__cell--half" role="columnheader">#</span>
        <span class="table__cell table__cell--one" role="columnheader" *ngFor="let field of fields">
          {{ field.label }}
        </span>
        <span class="table__cell table__cell--one" role="columnheader">Action</span>
      </span>
    </span>
    <div role="rowgroup">
      <span
        class="table__row"
        role="row"
        *ngFor="let record of pagedRecords; let i = index"
      >
        <span class="table__cell table__cell--half" role="cell">{{ (currentPage - 1) * pageSize + i + 1 }}</span>
        <span
          class="table__cell table__cell--one"
          role="cell"
          *ngFor="let field of fields"
          [class.cell-changed]="isChanged(record.rowIndex, field.key)"
          [title]="isChanged(record.rowIndex, field.key) ? getChangeTooltip(record.rowIndex, field.key) : ''"
        >
          {{ getFieldValue(record, field.key) }}
        </span>
       <span class="table__cell table__cell--one" role="cell">
          <span class="label" [class.label--success]="getActionLabel(record) === 'Created'" [class.label--info]="getActionLabel(record) === 'Updated'" [class.label--warning]="getActionLabel(record) === 'No Change'">
            {{ getActionLabel(record) }}
          </span>
        </span>
      </span>
    </div>
  </div>
  <generic-pagination
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [totalItems]="records.length"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
  ></generic-pagination>
</div>